import { createAtomFamily } from 'utils/recoil'
import { TOrderEntryProduct } from '../types'

export const productsStateFamily = createAtomFamily<TOrderEntryProduct[], string>({
  prefix: 'containers/OrderEntry/Products',
  key: 'products',
})
